export { Switch } from './Switch';
export type {
  SwitchBaseProps,
  SwitchBaseState,
  SwitchOnChangeData,
  SwitchProps,
  SwitchSlots,
  SwitchState,
} from './Switch.types';
export { renderSwitch_unstable } from './renderSwitch';
export { useSwitch_unstable, useSwitchBase_unstable } from './useSwitch';
export {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  switchClassName,
  switchClassNames,
  useSwitchStyles_unstable,
} from './useSwitchStyles.styles';
